import { FileSyncOutlined, LoadingOutlined } from '@ant-design/icons'
import { ErrorNotification, GraviButton, Horizontal, MomentDatePicker, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Dropdown, Form, Menu, Popover, Tooltip } from 'antd'
import { subDays } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { Simulate } from 'react-dom/test-utils'
import submit = Simulate.submit
import moment from 'moment'

import { formatters } from '../../../utils/intl/dateTimeFormatters'

export function DownloadButton({
  additionalFormats = [],
  onDownload,
  isLoading,
  showDatePicker,
  getDownload,
  setShowDatePicker,
}) {
  const downloadOptions = [{ title: 'Download Excel (.xlsx)', name: 'excel' }, ...additionalFormats]
  const [selectedRange, setSelectedRange] = useState({
    start_date: subDays(new Date(), 7),
    end_date: subDays(new Date(), 1),
  })
  const DownloadFormatsMenu = (
    <Menu
      onClick={(e) => onDownload(downloadOptions[e.key])}
      disabled={isLoading}
      items={downloadOptions.map((option, index) => ({
        key: index,
        label: option.title,
      }))}
    />
  )
  const [form] = Form.useForm()
  useEffect(() => {
    setSelectedRange({ start_date: subDays(new Date(), 7), end_date: subDays(new Date(), 1) })
    form.resetFields()
  }, [showDatePicker])

  const disabledDate = (current) => {
    const isAfterYesterday = current.isAfter(moment().subtract(1, 'day'), 'day')
    const tooEarly = selectedRange.start_date && Math.abs(current.diff(selectedRange.start_date, 'days')) > 31
    const tooLate = selectedRange.end_date && Math.abs(current.diff(selectedRange.end_date, 'days')) > 31
    return !!tooEarly || !!tooLate || !!isAfterYesterday
  }
  const dateRangeValidator = (rule, value, callback) => {
    if (!value) return callback('Please select a date.')
    if (value.isAfter(moment().subtract(1, 'day'), 'day')) callback('Select a past date.')
    if (moment(selectedRange.end_date).diff(selectedRange.start_date, 'days') > 31) {
      callback('Select 31 days or less')
    }
    callback()
  }

  const content = (
    <Vertical>
      <Form form={form} onFinish={getDownload} onFinishFailed={ErrorNotification}>
        <Horizontal verticalCenter className='p-2'>
          <Texto> Please select a range of 31 days or less to download.</Texto>
        </Horizontal>
        <Horizontal verticalCenter className='p-2'>
          <Vertical flex={1} className='mr-4'>
            <Texto>From Date</Texto>
            <Form.Item
              name='start_date'
              initialValue={moment(subDays(new Date(), 7))}
              rules={[{ validator: dateRangeValidator }]}
            >
              <MomentDatePicker
                showTime={false}
                disabledDate={disabledDate}
                format={formatters.DATE}
                onChange={(date) => setSelectedRange({ ...selectedRange, start_date: date })}
              />
            </Form.Item>
          </Vertical>
          <Vertical flex={1} className='ml-4'>
            <Texto>To Date</Texto>
            <Form.Item
              name='end_date'
              initialValue={moment(subDays(new Date(), 1))}
              rules={[{ validator: dateRangeValidator }]}
            >
              <MomentDatePicker
                showTime={false}
                disabledDate={disabledDate}
                format={formatters.DATE}
                onChange={(date) => setSelectedRange({ ...selectedRange, end_date: date })}
              />
            </Form.Item>
          </Vertical>
        </Horizontal>
        <hr style={{ border: '1px solid #eee' }} />
        <Horizontal verticalCenter justifyContent='flex-end' className='p-2'>
          <GraviButton onClick={() => setShowDatePicker(false)} buttonText='Cancel' />
          <GraviButton theme2 htmlType={submit} buttonText='Download' className='ml-4' />
        </Horizontal>
      </Form>
    </Vertical>
  )

  return (
    <Tooltip title='Work In Excel'>
      <Popover
        destroyTooltipOnHide
        visible={showDatePicker}
        content={content}
        title={<Texto category='h5'>Download by Date Range</Texto>}
      >
        <Dropdown.Button
          overlay={DownloadFormatsMenu}
          onClick={() => onDownload(downloadOptions[0])}
          disabled={isLoading}
        >
          {isLoading ? (
            <LoadingOutlined style={{ fontSize: '1.2em' }} />
          ) : (
            <FileSyncOutlined style={{ fontSize: '1.2em' }} />
          )}
        </Dropdown.Button>
      </Popover>
    </Tooltip>
  )
}
